<template>
  <div class="wrapper">
    <!--头部-->
    <div class="header-wrapper">
      <switch-tab :arr="arrtab" :selectIndex="selectIndex" @changeTab="changeTab"></switch-tab>
      <div class="header">{{selectIndex == 0 ? '社会组织' : '志愿组织'}}</div>
      <Button class="bkcc-btn btn" @click="showAddModal">新建</Button>
    </div>
    <!--点亮提示-->
    <div class="tishi">
      <tooltip placement="bottom-start" theme="light" max-width="290">
        <div slot="content" class="tooltip">
          <div>1.成员数超20人</div>
          <div>2.当月举办两次活动且每次活动有多于5人签到成功，下月即可点亮<i class="iconfont icon-daV"></i></div>
        </div>
        <div class="box tishi-box">
          <div class="iconfont icon-shuoming tishi-icon"></div>
          <div>如何点亮</div>
          <div class="iconfont icon-daV v-ivon"></div>
        </div>
      </tooltip>
    </div>
    <div class="tishi" v-if="selectIndex == 1">
      <tooltip placement="bottom-start" theme="light" max-width="290">
        <div slot="content" class="tooltip">
          <div>按活跃度排名</div>
          <div>活跃度计算规则：每人参与一次活动为组织积累1活跃度"</div>
        </div>
        <div class="box tishi-box">
          <div class="iconfont icon-shuoming tishi-icon"></div>
          <div>排名规则</div>
        </div>
      </tooltip>
    </div>
    <!--组织卡片们-->
    <org-card :org-list="orgList" @cardClick="cardClick" @init="init"></org-card>
    <!--底部页码-->
    <div class="page">
      <Page :total="orgTotal" :current="page" show-total :page-size="6" @on-change="pageChange" />
    </div>
    <!--新建弹窗-->
    <Modal
      v-model="showModal"
      title="新建组织"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <div style="height: 200px;">
        <div class="box">
          <div class="modal-title">组织名称</div>
          <Input placeholder="请输入组织名称" v-model="orgname" :maxlength="32" />
        </div>
      </div>

      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class type="text" @click="showModal = false">取消</Button>
        <Button class type="primary" :loading="btnLoading" @click="saveOrg">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
var that;
import orgCard from "./orgComponents/organizeCard";
import switchTab from "./components/switchTab";
export default {
  name: "organize",
  components: {
    orgCard,
    switchTab
  },
  data() {
    return {
      btnLoading: false,
      orgname: "", //新建弹窗中的输入框
      showModal: false, //是否显示新建弹窗
      total: 0, //当前数据总数
      filterList: [], //右侧筛选框
      orgList: [],
      orgTotal: 0,
      page: 1,
      rows: 6,
      communityId: parseInt(this.$store.state.streetorcommunityid),
      communityIdList: [],
      orgName: "", //搜索用组织名称
      arrtab: ["社会组织", "志愿组织"],
      selectIndex: 0,
      typeList: [12, 17],
      rule: {
        orderField: '',
        orderSeq: ''
      }
    };
  },
  watch: {
    /* 当前total发生变化时 右侧label显示跟着变化 */
    orgTotal(newVal) {
      this.$store.commit("updateLabelList", [
        {
          name: "filter_label",
          data: {
            label: "当前总数",
            value: newVal
          }
        }
      ]);
    }
  },
  methods: {
    //获取组织列表..
    getOrg() {
      this.$store.commit("updateSpinShow", true);
      var url = this.urlobj.getOrganize;
      var rule = this.rule
      console.log()
      console.log(this.communityIdList)
      console.log(this.rule)
      let data = {
        pageNum: this.page,
        pageSize: this.rows,
        communityIdList: this.communityIdList,
        orgName: this.orgName,
        comeType: this.typeList[this.selectIndex],
        ...rule
      }
      console.log(data)
      this.$post(url, data).then(res => {
         console.log(this.communityIdList)
        this.orgTotal = res.total;
        this.orgList = res.rows.map(item => {
          return {
            name: item.orgName,
            showCha: false, //是否显示右上角删除
            dianliang: item.isV, //是否被点亮
            chengyuan: item.memberCount, //成员数
            huodong: item.activityCount, //活动数
            paiming: item.scoreRank, //排名
            new: item.applyCount,
            id: item.id,
            total: res.total
          };
        });
        this.$store.commit("updateSpinShow", false);
      });
    },
    init() {
      this.page = 1;
      this.getOrg();
    },
    showAddModal() {
      var idlist = this.communityIdList
      if(this.$store.state.isJiedao == 1) {
        if(!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域")
          return
        }
      }
      this.showModal = true
    },
    // 新建组织
    saveOrg() {
      if (!this.orgname) {
        this.$Message.warning("请填写组织名称");
        return;
      }
      this.btnLoading = true;
      var url = this.urlobj.changeOrg;
      this.$post(url, {
        orgName: this.orgname,
        communityId: this.communityIdList.join(','),
        isV: 0,
        comeType: this.typeList[this.selectIndex]
      })
        .then(res => {
          this.btnLoading = false;
          this.$Message.success("新建成功");
          // this.orgList.push({
          //   name:this.orgname,
          //   showCha:false,//是否显示右上角删除
          //   dianliang:false,//是否被点亮
          //   chengyuan:0,//成员数
          //   huodong:0,//活动数
          //   paiming:0,//排名
          //   id:res.newPrimaryKeys.id
          // })
          this.showModal = false;
          this.orgname = "";
          this.page = 1;
          this.filterList = []
          this.getOrg();
          this.getfilter()
        })
        .catch(e => {
          this.btnLoading = false;
        });
    },
    //点击组织卡片 进入组织详情
    cardClick(item) {
      this.$router.push({
        name: "orgDetail",
        query: {
          id: item.id,
          communityId: this.communityId,
          type: this.typeList[this.selectIndex]
        }
      });
    },
    // 获取右侧筛选列表内容
    getfilter(isFirst) {
      this.filterList = []
      if (this.$store.state.isJiedao == 1) {
        var filterData = [];
        var _url = this.urlobj.getOrgNumByCom;
        this.$post(_url, {
          pageNum: 1,
          pageSize: 999,
          communityId: this.$store.state.streetorcommunityid,
          comeType: this.typeList[this.selectIndex]
        }).then(res => {
          //匹配index
          let index1 = ''
          var num = 0
          var ids = []
          var counts = []
          ids = res.rows.map(item => {
            return item.communityId
          })
          counts = res.rows.map(item => {
            return item.orgCount
          })
          counts.forEach(item => {
            num += item
          })
          var item1 = {
            name: '全部',
            id: ids.join(','),
            userCount: num
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
                id: item.communityId,
                userCount: item.orgCount
            };
          })
          list.unshift(item1)

          if(isFirst == 1 && this.$store.state.isJiedao){
            this.communityIdList = ids
          } 

          list.forEach((item, index) => {
            if(item.id == this.communityIdList) {
              index1 = index
            }
          })
          console.log(index1)
          filterData.push({
            type: "community",
            name: "行政区域",
            selectedIndex: index1,
            children: list
          });
          for (const obj in filterData) {
            this.filterList.push(new FilterItem(filterData[obj]));
          }
          this.initFilterList(this.filterList);
          console.log(this.filterList)
        });
      } else {
        setTimeout(() => {
          this.initFilterList(this.filterList);
        }, 500);
      }
      this.getOrg()
    },
    /* 初始化筛选列表 */
    initFilterList(list) {
      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function(e) {
          that[e.fn](e);
        }
      };
      let select = {
        name: "selecter",
        data: {
          title: "排序",
          selectList: [
            {
              title: "条件",
              list: [
                {
                  label: "活动数",
                  value: "activityCount"
                },
                {
                  label: "活跃度",
                  value: "score"
                },
                {
                  label: "成员数",
                  value: "memberCount"
                }
              ],
              model: '',
              value: 'orderField'
            },
            {
              title: "顺序",
              list: [
                {
                  label: "从大到小",
                  value: "DESC"
                },
                {
                  label: "从小到大",
                  value: "ASC"
                }
              ],
              model: '',
              value: 'orderSeq'
            }
          ]
        },
        event: function(e) {
          that[e.fn](e);
        }
      };
      list.unshift(search, select);
      this.$store.commit("updateFilterList", list);
    },
    changeTab(index) {
      //切换发送和草稿  1为草稿 0为发送
      that.selectIndex = index;
      this.filterList = []
      this.page = 1;
      this.orgName = "";
      this._reset();
      //this.getfilter(1)
    },
    /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/
    /* 重置筛选列表 */
    _reset() {
      this.title = "";
      this.communityIdList = this.$store.state.isJiedao?[]:[parseInt(this.$store.state.streetorcommunityid)];
      this.orgName = "";
      this.page = 1;
      this.getfilter(1)
      //this.getOrg();
      // if (this.selectIndex == 0) {
      //   //已发送活动
      //   this.activityList= []
      //   this.newRule ++
      // }else {
      //   this.activityList= []
      //   this.caogaoRule ++
      // }
    },
    /* ==================== 搜索  BEGIN==================== */
    search({ params }) {
      this.orgName = params.searchValue;
      this.page = 1;
      this.getOrg();
      // if (this.selectIndex == 0) {
      //   //已发送活动
      //   this.activityList= []
      //   this.newRule ++
      // }else {
      //   this.activityList= []
      //   this.caogaoRule ++
      // }
    },
    /* ==================== 搜索  END==================== */
    /* ==================== 排序  BEGIN==================== */
    sort({params}) {
      console.log(params.key)
      console.log(params.val)
      this.rule[params.key] = params.val
      this.getOrg()
    },
    /* ==================== 排序  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      this._groupChange(params);
    },
    /* 勾选筛选 初始化不同的属性*/
    _groupChange(e) {
      let target = this.filterList[e.filterListIndex];
      /* 修改筛选条件 source 传type 其他的传id*/
      if (target.type == "community") {
        var val1 = target.data.dataList[e.selectedIndex].id
        console.log(val1)
        var index = String(val1).indexOf(',')
        var idlist = index == -1 ? [val1] : val1.split(',')
        this.communityIdList = idlist;
        console.log(this.communityIdList)
        // this.getfilter();
      }
      this.page = 1;
      console.log('getOrg')
      this.getOrg();
    },
    // 页码改变
    pageChange(num) {
      this.page = num;
      this.getOrg();
    }
  },
  created() {
    this.reset = this._.debounce(this._reset, 500); // filter 重置后会触发
  },
  mounted() {
    that = this;
    this._reset();
    //this.getfilter(1);
  }
};
/* ---------------------------筛选组件构造对象 --------------------------*/
/*
    type : 用来确定 使用哪个组件
    name ：组件显示的头部文字
    children: 子列表数据
  */
function FilterItem({ type, name, children, selectedIndex }) {
  /* 如果是来源 获取图片路径 */
  /* 是否可编辑 以后扩展*/
  this.editMode = function(type) {
    switch (type) {
      case "category":
        return true;
        break;
      default:
        return false;
    }
  };
  /* 初始化 组件类型 this.name 确定组件类型*/
  switch (type) {
    case "community":
      this.name = "singleDivision";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: this.editMode(type),
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.userCount,
        iconPath: "",
        type: item.type || ""
      };
    })
  };
  if(selectedIndex > -1) {
    console.log(111)
    this.data.selectedIndex = selectedIndex
  }
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function(e) {
    that[e.fn](e);
  };
}
</script>

<style scoped lang="less">
.wrapper /deep/ .ivu-btn {
  padding: 1px 15px 2px;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.header-wrapper {
  display: flex;
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
  .header {
    font-size: 25px;
    text-align: center;
  }
  .btn {
    position: absolute;
    right: 20px;
  }
}
.tishi {
  color: #999;
  padding-left: 20px;
  line-height: 1;
  font-size: 16px;
  margin-bottom: 20px;
  display: inline-block;
  .tishi-box {
    align-items: center;
    .tishi-icon {
      color: #999;
      font-size: 20px;
      margin-right: 10px;
      padding-top: 1px;
    }
    .v-ivon {
      color: #c6c6c6;
      font-size: 19px;
      padding-top: 3px;
    }
  }
}
.tooltip {
  font-size: 15px;
  color: #666;
  .iconfont {
    color: #c6c6c6;
    font-size: 16px;
  }
}
.modal-title {
  align-self: center;
  width: 80px;
  text-align: left;
}
.page {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
